import { ElectionsAPIInstance } from "../../data-layer"
import {
  articleToElectionArticleInfo,
  campaignToCandidateInfo,
  candidateToCandidateInfo
} from "../selectors"

export class GetCandidatePropsUsecase {
  constructor(private readonly electionsAPI = ElectionsAPIInstance) {}

  async execute(slug: string) {
    const [candidate, campaigns, articles] = await Promise.all([
      this.electionsAPI.fetchCandidate(slug),
      this.electionsAPI.fetchCampaigns({
        candidate: slug
      }),
      this.electionsAPI.fetchElectionArticles()
    ])
    return {
      candidate: candidateToCandidateInfo(candidate),
      campaigns: (campaigns?.items || []).map(campaignToCandidateInfo),
      articles: (articles?.items || []).map(articleToElectionArticleInfo)
    }
  }
}
